import React, { Component } from "react"
import PropTypes from "prop-types"
import * as Icon from "react-feather"
import linkHandler from "../../helpers/storyblokLinkHandler"

import Components from "../../components"

import logo from "../../assets/images/logos/hult-logo-black.svg"
import logoMobile from "../../assets/images/logos/hult-logo-m.svg"
import logoAshridgeShield from "../../assets/images/logos/ashridge-shield.svg"

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayMenu: false,
      navExistsOnPage: true,
      isAshridgePage: false,
    }

    this.toggleMenu = this.toggleMenu.bind(this)
  }

  toggleMenu() {
    const { displayMenu } = this.state

    this.setState({
      displayMenu: !displayMenu,
    })
  }
  componentDidMount() {
    if (document.getElementsByClassName("navigation-v2").length === 0) {
      this.setState({
        navExistsOnPage: false,
      })
    }
    if (window.location.href.indexOf("executive-education") > -1) {
      this.setState({
        isAshridgePage: true,
      })
    }
  }

  render() {
    const { displayMenu } = this.state
    const { blok } = this.props

    return (
      <header
        className={`header${
          this.state.navExistsOnPage ? " header--program " : " "
        }animated`}
      >
        <div className="header__container header__container container container--no-margin">
          <a
            title="Hult"
            href={linkHandler(blok.logo_url)}
            className="header__branding"
          >
            <img
              alt=""
              className="header__logo header__logo--desktop"
              src={blok.logo || logo}
            />
            <img
              alt=""
              className="header__logo header__logo--mobile"
              src={this.state.isAshridgePage ? blok.logo : logoMobile}
            />
          </a>
          <nav
            className={`header__nav${
              displayMenu ? " header__nav--visible" : ""
            }`}
          >
            <div className="header__nav-top container container--no-margin">
              <a
                title="Hult"
                href={linkHandler(blok.logo_url)}
                className="header__branding header__branding--badge"
              >
                <img
                  alt=""
                  className="header__logo header__logo--mobile"
                  src={
                    this.state.isAshridgePage ? logoAshridgeShield : logoMobile
                  }
                />
              </a>
              <Icon.X onClick={this.toggleMenu} />
            </div>

            {blok.header_menu &&
              blok.header_menu.map((content) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                  className: "header__nav-item",
                })
              )}
            {this.state.isAshridgePage && (
              <>
                {blok.header_cta &&
                  blok.header_cta.map((content) => (
                    <div
                      key={content._uid}
                      className="header__nav-item header__nav-item--button"
                    >
                      {React.createElement(Components(content.component), {
                        key: content._uid,
                        blok: content,
                      })}
                    </div>
                  ))}
              </>
            )}
            {!this.state.navExistsOnPage && (
              <>
                {blok.header_cta &&
                  blok.header_cta.map((content) => (
                    <div
                      key={content._uid}
                      className="header__nav-item header__nav-item--button"
                    >
                      {React.createElement(Components(content.component), {
                        key: content._uid,
                        blok: content,
                      })}
                    </div>
                  ))}
              </>
            )}

            <div className="header__nav-bg" onClick={this.toggleMenu}></div>
          </nav>
          <Icon.Menu className="header__nav-burger" onClick={this.toggleMenu} />
        </div>
      </header>
    )
  }
}

Header.defaultProps = {
  blok: {},
}

Header.propTypes = {
  blok: PropTypes.shape({
    logo: PropTypes.string,
    logo_url: PropTypes.shape({
      linktype: PropTypes.string,
      url: PropTypes.string,
      cached_url: PropTypes.string,
    }),
    header_menu: PropTypes.arrayOf(PropTypes.object),
    header_cta: PropTypes.arrayOf(PropTypes.object),
  }),
}

export default Header
